import { LoadingOutlined } from '@common-web/icon/icons';
import { Icon, PopOver } from '@common-web/index';
import { Flex, Spin } from 'antd';
import { useState } from 'react';
import { FaEllipsisVertical } from 'react-icons/fa6';
import styles from './index.module.scss';

const EllipsisActions = ({ actions = [] }) => {
  const [popoverVisible, setPopoverVisible] = useState(false);

  const displayedActions = actions?.filter((action) => action?.show);

  if (!displayedActions?.length) {
    return null;
  }

  return (
    <Flex align="center" gap={10}>
      <PopOver
        visible={popoverVisible}
        setVisible={setPopoverVisible}
        content={displayedActions?.map((action) => (
          <Flex
            key={action?.text}
            align="center"
            gap={'10px'}
            className={styles?.popoverAction}
            onClick={
              !action?.loading
                ? () => {
                    action?.onClick();
                    if (action?.closeOnClick) {
                      setPopoverVisible(false);
                    }
                  }
                : () => {}
            }
          >
            {action?.icon && <Icon icon={action?.icon} iconSize="1.2em" />}
            <span className="fw-600">{action?.text}</span>
            {!!action?.loading && <Spin size={'sm'} indicator={<LoadingOutlined spin />} />}
          </Flex>
        ))}
        placement={'bottomLeft'}
        className={styles?.popover}
      >
        <div className={styles?.options}>
          <FaEllipsisVertical style={{ color: 'var(--ant-color-primary)', width: 20, height: 20 }} />
        </div>
      </PopOver>
    </Flex>
  );
};

export default EllipsisActions;
